<!-- Search & Filters -->
<div class="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
  @if (showSearch) {
  <div class="flex flex-col gap-3 sm:flex-row sm:items-center" [ngClass]="{'mr-auto': leftSideSearch}">
    <!-- Search input -->
    <div class="flex items-center rounded-md border border-grey p-2 gap-x-2">
      <svg class="" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.8045 18.8638L15.8252 14.8845C16.9096 13.5582 17.4428 11.8659 17.3144 10.1575C17.1861 8.44916 16.406 6.85549 15.1356 5.70615C13.8652 4.55681 12.2016 3.93974 10.4889 3.98256C8.77632 4.02538 7.14566 4.72482 5.93426 5.93622C4.72287 7.14761 4.02343 8.77827 3.9806 10.4909C3.93778 12.2035 4.55486 13.8671 5.7042 15.1375C6.85354 16.408 8.44721 17.188 10.1556 17.3164C11.8639 17.4447 13.5563 16.9116 14.8825 15.8271L18.8619 19.8065C18.9876 19.9279 19.156 19.9951 19.3308 19.9936C19.5056 19.9921 19.6728 19.922 19.7964 19.7984C19.92 19.6747 19.9901 19.5075 19.9916 19.3327C19.9932 19.1579 19.926 18.9895 19.8045 18.8638ZM10.6665 16.0018C9.61169 16.0018 8.58054 15.689 7.70348 15.103C6.82642 14.5169 6.14283 13.684 5.73916 12.7095C5.3355 11.7349 5.22988 10.6626 5.43567 9.62799C5.64145 8.59343 6.1494 7.64312 6.89529 6.89724C7.64117 6.15136 8.59147 5.64341 9.62604 5.43762C10.6606 5.23183 11.733 5.33745 12.7075 5.74112C13.682 6.14478 14.515 6.82837 15.101 7.70543C15.6871 8.5825 15.9999 9.61364 15.9999 10.6685C15.9983 12.0825 15.4359 13.4381 14.436 14.438C13.4362 15.4378 12.0805 16.0002 10.6665 16.0018Z"
          fill="#4A4C56" />
      </svg>

      <input [(ngModel)]="searchText" type="text" [placeholder]="searchPlaceholder" [disabled]="searchDisabled"
        [attr.title]="searchDisabled ? disabledHint : null"
        [class]="'w-full text-sm focus:border-primary-600 focus:outline-none placeholder:text-[#BEBFC1] ' + searchInputClass" />

      @if (searchText) {
      <svg (click)="onClear()" class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
      }
    </div>

    <!-- Search button -->
    <app-button class="w-full sm:w-auto" [buttonDisabled]="searchDisabled" (buttonClick)="onSearch()">
      Search
    </app-button>
  </div>
  }

  <div class="flex flex-wrap gap-3 sm:justify-end">
    <!-- Status -->
    @if(showStatus) {
    <div [matMenuTriggerFor]="menu" [class.pointer-events-none]="statusDisabled" [class.opacity-50]="statusDisabled"
      [attr.aria-disabled]="statusDisabled ? 'true' : null" [attr.title]="statusDisabled ? disabledHint : null"
      class="cursor-pointer flex w-full sm:w-auto items-center gap-2 rounded-md border border-[#E3E3E3] px-4 py-2 text-sm text-[#6B6B6A] active:bg-gray-100 transition-colors">
      <span>
        {{selectedArrayValue?.label || statusLabel}}
      </span>

      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.2788 5.96484L8.93208 10.3115C8.41875 10.8248 7.57875 10.8248 7.06542 10.3115L2.71875 5.96484"
          stroke="#4D4D4D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

    </div>
    }
    <!-- Date picker -->
    @if (showRangeFilter) {
    <div (click)="rangePicker.open()"
      class="relative overflow-hidden cursor-pointer flex w-full sm:w-auto items-center gap-2 rounded-md border border-[#E3E3E3] px-4 py-2 text-sm text-[#6B6B6A] active:bg-gray-100 transition-colors">
      @if (!startDate && !endDate ) {
      <span>
        {{ rangeLabel }}
      </span>
      }
      <mat-date-range-input [ngClass]="{'absolute opacity-0 pointer-events-none': (!startDate && !endDate)}"
        [rangePicker]="rangePicker">
        <input [(ngModel)]="startDate" readonly class="focus:outline-none focus:ring-0 focus:ring-offset-0"
          matStartDate>
        <input (dateChange)="onDateRangeChange()" [(ngModel)]="endDate" readonly
          class="focus:outline-none focus:ring-0 focus:ring-offset-0" matEndDate>
      </mat-date-range-input>
      <mat-date-range-picker #rangePicker></mat-date-range-picker>

      @if (!startDate && !endDate) {
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.9997 2.66536H10.9997V1.66536C10.9997 1.57696 10.9646 1.49217 10.902 1.42966C10.8395 1.36715 10.7547 1.33203 10.6663 1.33203C10.5779 1.33203 10.4932 1.36715 10.4306 1.42966C10.3681 1.49217 10.333 1.57696 10.333 1.66536V2.66536H5.66634V1.66536C5.66634 1.57696 5.63122 1.49217 5.56871 1.42966C5.5062 1.36715 5.42141 1.33203 5.33301 1.33203C5.2446 1.33203 5.15982 1.36715 5.09731 1.42966C5.03479 1.49217 4.99967 1.57696 4.99967 1.66536V2.66536H2.99967C2.55781 2.66589 2.13419 2.84166 1.82175 3.1541C1.5093 3.46655 1.33354 3.89017 1.33301 4.33203V12.9987C1.33354 13.4406 1.5093 13.8642 1.82175 14.1766C2.13419 14.4891 2.55781 14.6648 2.99967 14.6654H12.9997C13.4416 14.665 13.8653 14.4893 14.1778 14.1768C14.4903 13.8643 14.666 13.4406 14.6663 12.9987V4.33203C14.666 3.89011 14.4903 3.46639 14.1778 3.15391C13.8653 2.84143 13.4416 2.66572 12.9997 2.66536ZM13.9997 12.9987C13.9997 13.2639 13.8943 13.5183 13.7068 13.7058C13.5192 13.8933 13.2649 13.9987 12.9997 13.9987H2.99967C2.73446 13.9987 2.4801 13.8933 2.29257 13.7058C2.10503 13.5183 1.99967 13.2639 1.99967 12.9987V7.33203H13.9997V12.9987ZM13.9997 6.66536H1.99967V4.33203C1.99967 3.78003 2.44634 3.33203 2.99967 3.33203H4.99967V4.33203C4.99967 4.42044 5.03479 4.50522 5.09731 4.56773C5.15982 4.63025 5.2446 4.66536 5.33301 4.66536C5.42141 4.66536 5.5062 4.63025 5.56871 4.56773C5.63122 4.50522 5.66634 4.42044 5.66634 4.33203V3.33203H10.333V4.33203C10.333 4.42044 10.3681 4.50522 10.4306 4.56773C10.4932 4.63025 10.5779 4.66536 10.6663 4.66536C10.7547 4.66536 10.8395 4.63025 10.902 4.56773C10.9646 4.50522 10.9997 4.42044 10.9997 4.33203V3.33203H12.9997C13.2649 3.33203 13.5192 3.43739 13.7068 3.62492C13.8943 3.81246 13.9997 4.06681 13.9997 4.33203V6.66536Z"
          fill="#929292" />
      </svg>
      } @else {
      <svg width="16" height="16" (click)="$event.stopPropagation(); onClearDate()" xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
      }
    </div>
    }

    @if (showDateFilter) {
    <div (click)="picker.open()"
      class="relative overflow-hidden cursor-pointer flex w-full sm:w-auto items-center gap-2 rounded-md border border-[#E3E3E3] px-4 py-2 text-sm text-[#6B6B6A] active:bg-gray-100 transition-colors">
      <div>
        <input (dateChange)="onDateChange()" [ngClass]="{'w-10': !startDate}" readonly [(ngModel)]="startDate"
          class="focus:outline-none focus:ring-0 focus:ring-offset-0" placeholder="Date" [matDatepicker]="picker">
        <mat-datepicker #picker></mat-datepicker>
      </div>

      @if (!startDate ) {
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.9997 2.66536H10.9997V1.66536C10.9997 1.57696 10.9646 1.49217 10.902 1.42966C10.8395 1.36715 10.7547 1.33203 10.6663 1.33203C10.5779 1.33203 10.4932 1.36715 10.4306 1.42966C10.3681 1.49217 10.333 1.57696 10.333 1.66536V2.66536H5.66634V1.66536C5.66634 1.57696 5.63122 1.49217 5.56871 1.42966C5.5062 1.36715 5.42141 1.33203 5.33301 1.33203C5.2446 1.33203 5.15982 1.36715 5.09731 1.42966C5.03479 1.49217 4.99967 1.57696 4.99967 1.66536V2.66536H2.99967C2.55781 2.66589 2.13419 2.84166 1.82175 3.1541C1.5093 3.46655 1.33354 3.89017 1.33301 4.33203V12.9987C1.33354 13.4406 1.5093 13.8642 1.82175 14.1766C2.13419 14.4891 2.55781 14.6648 2.99967 14.6654H12.9997C13.4416 14.665 13.8653 14.4893 14.1778 14.1768C14.4903 13.8643 14.666 13.4406 14.6663 12.9987V4.33203C14.666 3.89011 14.4903 3.46639 14.1778 3.15391C13.8653 2.84143 13.4416 2.66572 12.9997 2.66536ZM13.9997 12.9987C13.9997 13.2639 13.8943 13.5183 13.7068 13.7058C13.5192 13.8933 13.2649 13.9987 12.9997 13.9987H2.99967C2.73446 13.9987 2.4801 13.8933 2.29257 13.7058C2.10503 13.5183 1.99967 13.2639 1.99967 12.9987V7.33203H13.9997V12.9987ZM13.9997 6.66536H1.99967V4.33203C1.99967 3.78003 2.44634 3.33203 2.99967 3.33203H4.99967V4.33203C4.99967 4.42044 5.03479 4.50522 5.09731 4.56773C5.15982 4.63025 5.2446 4.66536 5.33301 4.66536C5.42141 4.66536 5.5062 4.63025 5.56871 4.56773C5.63122 4.50522 5.66634 4.42044 5.66634 4.33203V3.33203H10.333V4.33203C10.333 4.42044 10.3681 4.50522 10.4306 4.56773C10.4932 4.63025 10.5779 4.66536 10.6663 4.66536C10.7547 4.66536 10.8395 4.63025 10.902 4.56773C10.9646 4.50522 10.9997 4.42044 10.9997 4.33203V3.33203H12.9997C13.2649 3.33203 13.5192 3.43739 13.7068 3.62492C13.8943 3.81246 13.9997 4.06681 13.9997 4.33203V6.66536Z"
          fill="#929292" />
      </svg>
      } @else {
      <svg (click)="$event.stopPropagation(); onClearDate()" width="16" height="16" xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
      }


    </div>
    }

    <!-- Download -->
    @if (showDownload) {
    <div (click)="onDownload()" [class.pointer-events-none]="downloadDisabled" [class.opacity-50]="downloadDisabled"
      [attr.aria-disabled]="downloadDisabled ? 'true' : null" [attr.title]="downloadDisabled ? disabledHint : null"
      class="cursor-pointer flex items-center justify-center gap-2 rounded-md border border-primary p-2 text-sm w-full sm:w-auto">
      @if (isDownloading) {
      <app-spinning-loader [width]="'16'" [inputClass]="'text-primary'" />
      } @else {
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.66797 10.6693V11.3333C2.66797 11.8638 2.87868 12.3725 3.25376 12.7475C3.62883 13.1226 4.13754 13.3333 4.66797 13.3333H11.3346C11.8651 13.3333 12.3738 13.1226 12.7488 12.7475C13.1239 12.3725 13.3346 11.8638 13.3346 11.3333V10.6667M8.0013 3V10.3333M8.0013 10.3333L10.3346 8M8.0013 10.3333L5.66797 8"
          stroke="#253A81" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

      }
    </div>
    }
  </div>

</div>

<mat-menu class="!bg-white !rounded-md !shadow-md " #menu="matMenu">
  <div class="flex flex-col gap-2 p-2 w-52 max-h-64 overflow-y-auto">
    @for (status of statusArray; track status) {
    <button (click)="onStatusChange(status)"
      class="cursor-pointer flex gap-2 items-center bg-[#F7F7F7] px-4 py-2 rounded-md hover:bg-gray-100 w-full disabled:bg-gray-100 disabled:opacity-50">
      <span>
        {{status.label}}
      </span>
    </button>
    }
  </div>
</mat-menu>
